import { Box } from "@chakra-ui/react";
import { FC, ReactElement, useEffect, useState } from "react";
import PartnerService from "services/partners/partner-service";
import LogosTable from "components/table";

interface PartnerHistoryProps {
    partner: any
}

const PartnerHistory: FC<PartnerHistoryProps> = ({ partner }) => {
    const [partnerBalanceHistories, setPartnerBalanceHistories] = useState<any>([]);
    const [totalHistory, setTotalHistory] = useState<number>(0);
    const [maxCountResult, setMaxCountResult] = useState<number>(100);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        setIsLoading(true);
        PartnerService.GetBalanceHistoryByPartnerId(partner.id, 0, maxCountResult).then((res: any) => {
            if (res.result) {
                setPartnerBalanceHistories(res.result.items);
                setTotalHistory(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    if (isLoading)
        return <Box>Loading...</Box>;

    return (
        <Box>
            <Box>
                <LogosTable
                    caption={'Riwayat Transaksi'}
                    headers={[{ label: 'Tanggal' }, { label: 'Keterangan' }, { label: 'Jumlah', isNumeric: true }, { label: 'Saldo', isNumeric: true }]}
                    rows={[{ propertyName: 'date', isDatetime: true }, { propertyName: 'remarks' }, { propertyName: 'amount', isNumeric: true }, { propertyName: 'balance', isNumeric: true }]}
                    data={partnerBalanceHistories}
                />
            </Box>
        </Box>
    );
};

export default PartnerHistory;